import Swiper, { Navigation, Autoplay } from 'swiper'

const Locations = () => {
  const swiper = new Swiper('.locations_slider', {
    modules: [Autoplay, Navigation],

    direction: 'vertical',
    slidesPerView: 'auto',
    spaceBetween: 24,
    
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },

    navigation: {
      nextEl: '.locations_slider_wrap .slider-button-next',
      prevEl: '.locations_slider_wrap .slider-button-prev',
    },
    
  })
}

export default Locations 